var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreationWizardStepHeaderWrapper',_vm._g(_vm._b({},'CreationWizardStepHeaderWrapper',_vm.headerWrapperProps,false),_vm.headerWrapperListeners),[_c('h1',{staticClass:"med"},[_vm._v("To add add-ons - use the extension")])])
}
var staticRenderFns = []

export { render, staticRenderFns }